export const AppURL = {
    Login : 'login',
    TermCondition : 'term/condition',
    Admin : 'admin'
};
